
const tokenizeCardCredentials = async ({dispatch}) => {
  try {
    if (document && document.hfields) {
      const result = await new Promise((resolve, reject) => {
        document.hfields.createToken((result) => resolve(result));
      }) 
      console.log('debug', 'tokenization result', result); // Debug
      const { hfToken, message, execCode } = result;
      if (execCode == '0000') {
        dispatch('setDalenysToken', hfToken);
        dispatch('setTokenizationError',''); // reseting previous errors
      }
      else {
        dispatch('setTokenizationError',message);
        dispatch('setDalenysToken', '');
        throw 'token generation failure'
      }
    }
  }
  catch(error) {
    return false;
  };
  return true;
}

/**
 * @param {Object} state
 * @param {String} token
 */
const setDalenysToken = (state, token) => {
  state.commit("SET_DALENYS_TOKEN", token);
};

/**
 * @param {Object} state
 * @param {String} error
 */
const setTokenizationError = (state, error) => {
  state.commit("SET_TOKENIZATION_ERROR", error);
};

/**
 * @param {Object} state
 * @param {Object} method
 */
const setChoosenPaymentMethod = (state, method) => {
  state.commit("SET_CHOOSEN_METHOD", method);
};

/**
 * @param {Object} state
 * @param {Array} methods
 */
const setPaymentMethods = (state, methods) => {
  state.commit("SET_METHODS", methods);
};

/**
 * @param {Object} state
 * @param {Object} hostedFields
 */
const setHostedFields = (state, hostedFields) => {
  state.commit("SET_HOSTED_FIELDS", hostedFields);
};


export default {
  setDalenysToken,
  setTokenizationError,
  tokenizeCardCredentials,
  setPaymentMethods,
  setChoosenPaymentMethod,
  setHostedFields
};
